import { Company } from 'types/company';

export interface ReportCompanyHeader {
  registeredBusinessName: string;
  registeredBusinessAddress: string;
  registeredBusinessTin: string;
}

export interface ReportHeaderMetadata extends ReportCompanyHeader {
  reportTitle: string;
}

const FALLBACK_VALUE = 'N/A';

/** Use when deciding whether to render a company header line (hide empty / placeholder). */
export function isReportHeaderValuePresent(
  value: string | undefined | null,
): boolean {
  if (value == null) return false;
  const t = value.trim();
  if (!t) return false;
  if (t.toUpperCase() === 'N/A') return false;
  return true;
}

export const getReportCompanyHeader = (
  company: Pick<Company, 'name' | 'address' | 'tin'> | null,
): ReportCompanyHeader => {
  return {
    registeredBusinessName: company?.name?.trim() || FALLBACK_VALUE,
    registeredBusinessAddress: company?.address?.trim() || FALLBACK_VALUE,
    registeredBusinessTin: company?.tin?.trim() || FALLBACK_VALUE,
  };
};
